import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {URLS} from '../../data/navigation/navigation.data';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  URLS = URLS;

  constructor(private router: Router) {
    // Intentionally blank
  }

  redirect(url: string, queryParams = {}) {

    if (!url) {
      return;
    }

    if (url.startsWith('/')) {
      // Scroll-to-top is handled centrally on NavigationEnd (LandingLayout).
      // The old per-redirect smooth scrollIntoView competed with it and was
      // unreliable on iOS (and `!== undefined` never caught a null lookup).
      this.router.navigate([url], {queryParams});
    } else {
      window.open(url, '_blank');
    }
  }
}
